import { z } from "zod";
import { toObjectMap } from "../../utilities/dictionary";

const unitTypes = [
    "pcs",
    "portion",
    "bottle",
    "glass",
    "cl",
    "hour",
    "day",
    "night",
    "minute",
    "second",
    "millisecond",
    "morning",
    "afternoon",
    "ticket",
    "participant",
    "accommodation",
] as const;
type UnitType = (typeof unitTypes)[number];
const unitTypeMap = toObjectMap<UnitType>([...unitTypes]);

const unitTypeZodSchema = z.enum(unitTypes);

export { unitTypeMap, unitTypeZodSchema, unitTypes };
export type { UnitType };
